import PropertyManagementContainer from './PropertyManagementContainer'
export default PropertyManagementContainer
